import { Header } from "./Header";

interface StoreNavigation02Props {
  logo?: string | null;
  siteName?: string;
  menu?: { title: string; path: string }[];
  navbar_direction?: "auto" | "rtl" | "ltr";
  customMenus?: any[]; // Using any[] to avoid import issues, or import Menu type
  basePath?: string;
  showSearch?: boolean;
  searchPlaceholder?: string;
  showCart?: boolean;
  showWishlist?: boolean;
  enableCustomerAccounts?: boolean;
}

export function StoreNavigation02({
  logo,
  siteName,
  menu,
  navbar_direction,
  customMenus,
  basePath,
  showSearch,
  searchPlaceholder,
  showCart,
  showWishlist,
  enableCustomerAccounts
}: StoreNavigation02Props) {
  return (
    <div className="flex flex-col w-full">
      <Header
        logo={logo}
        siteName={siteName}
        menu={menu}
        navbar_direction={navbar_direction}
        customMenus={customMenus}
        basePath={basePath}
        showSearch={showSearch}
        searchPlaceholder={searchPlaceholder}
        showCart={showCart}
        showWishlist={showWishlist}
        enableCustomerAccounts={enableCustomerAccounts}
      />
    </div>
  );
}
